/**
 * 数据库接口
 * @author： xuyd
 * @date：2024-05-02
 */
import request from "@/utils/request.js"

import {context} from '@/config/env.js'
const serviceModule = context.sunflower

export default {

  /**
   * 检索列表
   */
  searchList: (params) => {
    return request.post(serviceModule + "/datasvc/datasource/search", params);
  },

  /**
   * 获取信息
   */
  getInfo: (id) => {
    let params = {id: id}
    return request.get(serviceModule + "/datasvc/datasource/info/get", {params});
  },

  /**
   * 保存信息
   */
  saveInfo: (params) => {
    return request.post(serviceModule + "/datasvc/datasource/info/save", params);
  },

  /**
   * 删除
   * @param id id
   */
  deleteInfo: (id) => {
    return request.get(serviceModule + "/datasvc/datasource/delete?id=" + id);
  },
  /**
   * 测试连接
   * @param id id
   */
  testConn: (id) => {
    return request.get(serviceModule + "/datasvc/datasource/test?id=" + id);
  },
  /**
   * 加密
   * @param val
   */
  encrypt: (val) => {
    return request.get(serviceModule + "/datasvc/datasource/encrypt?pwd=" + val);
  },

  /**
   * 下拉
   */
  selectList: () => {
    return request.get(serviceModule + "/datasvc/datasource/select");
  },

}
